export default function replaceAt(arr, index, item) {
  if (item) {
    if (index < 0) {
      return [item, ...arr]
    } else {
      return [
        ...arr.slice(0, index),
        item,
        ...arr.slice(index + 1)
      ]
    }
  } else {
    if (index < 0) {
      return arr
    } else {
      return [
        ...arr.slice(0, index),
        ...arr.slice(index + 1)
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./client/utils/replaceAt.js